import Progress from '../views/Occurrence/Progress'
import Finished from '../views/Occurrence/Finished'

let routes = {
    path: '/occurrences',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/occurrences_progress',
            name: 'list-occurrence-progress',
            component: Progress,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Ocorrências em Andamento',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/occurrences_finished',
            name: 'list-occurrence-finished',
            component: Finished,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Ocorrências Finalizadas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
